import filterCollections from './filterCollections';

function getNumberOfFilteredSamples(): number {
  const collections = filterCollections();
  const numberOfFabrics = collections.reduce((acc, group) => {
    return acc + group.fabrics.length;
  }, 0);

  return numberOfFabrics;
}

export default getNumberOfFilteredSamples;
